import { render } from "./ThePanelSubmenu.vue?vue&type=template&id=86e729a6"
import script from "./ThePanelSubmenu.vue?vue&type=script&lang=js"
export * from "./ThePanelSubmenu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/albert/Develop/Dashboard/dashboard-frontend-private/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])